import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const milestones = [
  {
    date: '1995',
    title: 'Punjab Carpentry',
    description:
      'Founded in 1995 in Umm Al Quwain, Punjab Carpentry is a trusted name in bespoke furniture and interior woodwork.',
    image: '/global/punjab.webp',
    imageHint: 'Punjab logo',
  },
  {
    date: '1998',
    title: 'Emirates Secretarial Services (ESS)',
    description:
      'Emirates Secretarial Services (ESS) was founded in the UAE to provide reliable, high quality government related services.',
    image: '/global/ess.webp',
    imageHint: 'ESS Group logo',
  },
  {
    date: '1998',
    title: 'Astithna',
    description:
      'Establishes as a professional PRO services company specializing in Government liaison, document clearance and business setup support in the UAE.',
    image: '/global/astithna.webp',
    imageHint: 'Astithna logo',
  },
  {
    date: '2014',
    title: 'Real Estate Services',
    description:
      'As a trustee office, we signed a strategic agreement with the Dubai Land Department, enabling real estate-related government services.',
    image: '/global/real-estate-ess.webp',
    imageHint: 'Real Estate ESS logo',
  },
  {
    date: '2016',
    title: 'MOFA Recognition',
    description:
      'Recognised by MOFA to provide UAE embassy attestation for all countries along with many other document legalization and attestation services.',
    image: '/global/atlas.webp',
    imageHint: 'Atlas logo',
  },
  {
    date: '2025',
    title: 'Launch of UBER E-Visa',
    description:
      'We launch e-visa services for UAE and Saudi Arabia by acquiring brand UBER e-visa services.',
    image: '/logo.svg',
    imageHint: 'Uber E-Visa logo',
  },
];

export function Milestones() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    slidesToScroll: 1,
    align: 'start',
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="w-full">
      <div className="text-center mb-12 gsap-wwa-milestones-title">
        <h2 className="text-primary font-semibold mb-2">OUR JOURNEY</h2>
        <h3 className="text-4xl md:text-5xl font-bold text-neutral-800">
          History & Milestones
        </h3>
        <p className="mt-4 text-lg text-muted-foreground max-w-3xl mx-auto">
          Follow our journey from a humble beginning to a trusted name in global
          visa services.
        </p>
      </div>

      <div className="relative max-w-7xl mx-auto gsap-wwa-milestones-carousel">
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex -ml-4">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className="flex-[0_0_100%] md:flex-[0_0_25%] min-w-0 pl-4 h-full"
              >
                <div className="h-full flex flex-col items-center text-center p-4">
                  <div className="relative w-full h-24 mb-4 flex justify-center items-center">
                    <img
                      src={milestone.image}
                      alt={milestone.imageHint}
                      className="object-contain max-h-24"
                    />
                  </div>
                  <div className="flex flex-col flex-grow">
                    <p className="text-sm font-bold text-primary">
                      {milestone.date}
                    </p>
                    <h4 className="text-lg font-bold mt-1">{milestone.title}</h4>
                    <p className="mt-2 text-sm text-muted-foreground flex-grow">
                      {milestone.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <Button
          onClick={scrollPrev}
          variant="ghost"
          size="icon"
          className="absolute top-1/2 -left-6 -translate-y-1/2 rounded-full h-14 w-14 bg-white/80 backdrop-blur-sm hover:bg-white shadow-md z-10 hidden md:inline-flex"
        >
          <ArrowLeft className="h-8 w-8 text-primary" />
        </Button>
        <Button
          onClick={scrollNext}
          variant="ghost"
          size="icon"
          className="absolute top-1/2 -right-6 -translate-y-1/2 rounded-full h-14 w-14 bg-white/80 backdrop-blur-sm hover:bg-white shadow-md z-10 hidden md:inline-flex"
        >
          <ArrowRight className="h-8 w-8 text-primary" />
        </Button>
      </div>
    </div>
  );
}
